import WebpackerSvelte from "webpacker-svelte";
import Giftcard from "./giftcard/giftcard.svelte"

WebpackerSvelte.setup({ Giftcard });
